import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "../assets/wamglammz-logo.png";
import logo2 from "../assets/wamglammz-logo2.png";

const navItems = [
    { to: "/", label: "Home" },
    // { to: "/book/aurora-artistry", label: "Book Services" },
    { to: "/why-wamglammz", label: "Why Wamglammz" },
    { to: "/about", label: "About us" },
    { to: "/resource", label: "Resources" },
    { to: "/features", label: "Features" },
];

export default function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const closeMenu = () => setMenuOpen(false);

    return (
        <nav className="w-full bg-white/70 backdrop-blur-md shadow-sm sticky top-0 z-50 relative">
            <div className="max-w-[1536px] mx-auto px-6 md:px-12 py-4 flex items-center justify-between gap-5">
                <Link to="/" onClick={closeMenu} className="flex items-center gap-2 cursor-pointer shrink-0">
                    <img src={logo} alt="WamGlammz Logo" className="h-8 md:h-10 object-contain" />
                    <img src={logo2} alt="WamGlammz Secondary Logo" className="h-6 md:h-8 object-contain" />
                </Link>

                <ul className="hidden lg:flex items-center gap-5 xl:gap-8">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={({ isActive }) =>
                                isActive ? "nav-link active whitespace-nowrap" : "nav-link whitespace-nowrap"
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}

                    <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLSclujCjJKuYXRS7gY4cEk4b3NjhZ3aa_qPw6-SLm_jHSP8W4Q/viewform"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nav-link cursor-pointer whitespace-nowrap"
                    >
                        Suggestions
                    </a>
                </ul>

                <div className="flex items-center gap-3 shrink-0">
                    <NavLink
                        to="/for-business"
                        className={({ isActive }) =>
                            `hidden md:flex h-10 items-center whitespace-nowrap rounded-xl border px-5 text-sm font-bold transition ${
                                isActive
                                    ? "border-blue-600 bg-blue-600 text-white"
                                    : "border-blue-200 text-blue-700 hover:bg-blue-50"
                            }`
                        }
                    >
                        For Business
                    </NavLink>

                    <button
                        onClick={() => window.open("https://apps.apple.com/us/app/wamglammz/id1613316234", "_blank")}
                        className="hidden md:block whitespace-nowrap bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-xl text-sm font-medium transition"
                    >
                        Download App
                    </button>

                    <button
                        className="lg:hidden text-2xl text-gray-900 p-1 focus:outline-none"
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Toggle Menu"
                    >
                        <i className={`fa-solid ${menuOpen ? "fa-xmark" : "fa-bars"}`} aria-hidden="true" />
                    </button>
                </div>
            </div>

            {menuOpen && (
                <div className="lg:hidden absolute top-full left-0 w-full bg-white shadow-lg border-t border-gray-100 px-6 py-6 flex flex-col gap-6 z-50">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            onClick={closeMenu}
                            className={({ isActive }) =>
                                isActive ? "nav-link active text-blue-600 font-semibold" : "nav-link text-gray-700 font-medium"
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}

                    <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLSclujCjJKuYXRS7gY4cEk4b3NjhZ3aa_qPw6-SLm_jHSP8W4Q/viewform"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nav-link text-gray-700 font-medium cursor-pointer"
                        onClick={closeMenu}
                    >
                        Suggestions
                    </a>

                    <Link
                        to="/for-business"
                        onClick={closeMenu}
                        className="bg-white border border-blue-200 text-blue-700 px-6 py-3 rounded-xl text-sm font-semibold shadow-sm w-full text-center"
                    >
                        For Business
                    </Link>

                    <button
                        onClick={() => {
                            window.open("https://apps.apple.com/us/app/wamglammz/id1613316234", "_blank");
                            closeMenu();
                        }}
                        className="bg-gradient-to-r from-[#0A3FB6] to-[#2FB4FF] text-white px-6 py-3 rounded-xl text-sm font-semibold shadow-md w-full"
                    >
                        Download App
                    </button>
                </div>
            )}
        </nav>
    );
}
